import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';

import { Col, FormGroup, Select, Label, Row, Switch, Separator } from 'twyne-new.ui';

import Rules from 'components/rules/Rules';

import { extraRuleFields } from '../fieldsUtil';

const propTypes = {
  value: PropTypes.object,
  field: PropTypes.string,
  visibility: PropTypes.object,
  onChange: PropTypes.func,
  autohide: PropTypes.bool
};

export default class ControlCardVisibility extends React.Component {
  state = {
    rules: {
      actions: []
    }
  }

  componentDidMount() {
    const { autohide = false, actions = [], type = 'hide' } = this.props.value || {}
    this.setState({
      rules: { autohide: this.props.autohide || autohide, actions, type }
    })
  }

  get visibility() {
    return this.props.visibility
  }

  get types() {
    const types = []

    if (this.visibility.showControl)
      types.push({ label: "Show", value: 'show' })

    if (this.visibility.hideControl)
      types.push({ label: "Hide", value: 'hide' })

    return types
  }

  handleChange = rules => {
    rules = { ...this.state.rules, ...rules }
    this.setState({ rules })
    this.props.onChange(rules)
  }

  ControlRules = () => {
    const { actions: [{ rules } = {}] = [], type } = this.state.rules

    const [enabled, setEnabled] = useState(false)

    useEffect(() => {
      setEnabled(!!rules)
    }, [rules])

    const handleToogle = useCallback(() => {
      setEnabled(!enabled)
      if (enabled) {
        this.props.onConflict && this.props.onConflict('no-conflict')
        this.handleChange({ actions: [] })
      } else {
        this.handleChange({ actions: [{ rules: { condition: 'and', groups: [] } }] })
      }
    }, [enabled])

    return <>
      <Col size='12'>
        <div className='flex items-center justify-between'>
          <span className='text-md twy-text-base-accent'>Rules</span>
          <FormGroup>
            <Label>Enabled</Label>
            <Switch
              checked={enabled}
              onChange={handleToogle}
            />
          </FormGroup>
        </div>
      </Col>
      {enabled && <Col size='12'>
        <Rules
          rules={rules}
          origin='form-visibility'
          handleChange={rules => this.handleChange({ actions: [rules] })}
          extraFields={extraRuleFields}
          onConflict={this.props.onConflict}
        />
      </Col>}
    </>
  }

  render() {
    const { autohide, type } = this.state.rules
    return <>
      <Row>
        <Col size='10'>
          <FormGroup>
            <Label>Control Type</Label>
            <Select
              value={type}
              options={this.types}
              onChange={item => this.handleChange({ type: item && item.value })}
            />
          </FormGroup>
        </Col>
        {this.visibility.autohide && <Col size='2'>
          <FormGroup>
            <Label>Auto Hide</Label>
            <Switch
              checked={autohide || false}
              onChange={() => this.handleChange({ autohide: !autohide })}
            />
          </FormGroup>
        </Col>}
        <Col size='12'>
          <Separator />
        </Col>
        <this.ControlRules />
      </Row>
    </>
  }
}

ControlCardVisibility.propTypes = propTypes
ControlCardVisibility.defaultProps = {}